import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  AMOUNT_STORES_REFETCH_INTERVAL,
  amountStoresQueryOptions
} from '@queries/index';
import { defaultItems } from '../constants';
import { createDeliveryTitle } from '../utils';
import { useStores } from '@root/src/stores';
import type { GetAmountStoresQuery } from '@schema/main';

export type StoreItem = GetAmountStoresQuery['getAmountStores'][number] & {
  delivery: string;
  name: string;
};

const useStorePolling = (): StoreItem[] => {
  const { cartStore } = useStores();

  const { data } = useQuery({
    ...amountStoresQueryOptions(),
    refetchInterval: AMOUNT_STORES_REFETCH_INTERVAL
  });

  useEffect(() => {
    if (data?.getAmountStores) {
      cartStore.setAmountStores(data.getAmountStores);
    }
  }, [cartStore, data]);

  return useMemo(() => {
    if (!data?.getAmountStores) {
      // defaultItems is a lightweight placeholder shown before the real stores load.
      return defaultItems as unknown as StoreItem[];
    }

    const newItems: StoreItem[] = [];
    data.getAmountStores.forEach(item => {
      if (item) {
        newItems.push({
          ...item,
          delivery: createDeliveryTitle(item),
          name:
            item?.type === 'delivery' ? 'Ближайшая доставка' : item.name || ''
        });
      }
    });
    return newItems;
  }, [data]);
};

export default useStorePolling;
